import { ConfigurationsConstants } from './configurations.constants'
import { IConfigurationsAction, IConfigurationsState } from './configurations.types'

export const initialConfigurationsState: IConfigurationsState = {
  serviceConfig: {
    DEFAULT_TEMP_MEASUREMENT: null,
    DEFAULT_LENGTH_MEASUREMENT: null,
    DEFAULT_WEIGHT_MEASUREMENT: null,
    DEST_CONDITION_OR_FINAL_ACUITY: 0,
    DRUGALC_DEFAULT: null,
    ENCOUNTER_DEFAULT: null,
    EMD_DEFAULT: null,
    FORCE_MILEAGE_TENTHS: 0,
    FORCE_PT_SEARCH: 0,
    MASSCAS_DEFAULT: null,
    OUTCOME_DEFAULT: null,
    PR_COMPDURATION: 0,
    PR_PMHX_LAYOUT: 0,
    PR_PG_NARRATIVE: 0,
    PR_USNG: 0,
    PR_PT_MOVEMENT: 0,
    PR_PTS_ONSCENE: 0,
    PR_ODOM: 0,
    PR_LPM: 0,
    PR_DISPATCH_ID: 0,
    PR_DISPATCHED_AS: 0,
    PR_DISP_DELAY: 0,
    PR_TURNAROUND_DELAY: 0,
    REFTYPE_DEFAULT: null,
    RECUNIT_DEFAULT: null,
    RECTYPE_DEFAULT: null,
    SCENE_DEFAULT: null,
    SCHED_DEFAULT: null,
    STAFF_DEFAULT: null,
    TIMEZONE: 0,
    PR_NEMSIS35_DISPOSITION: 0,
    PR_REQ_CHART_ATTACH_CATEGORY: 0,
    PR_PT_CRITERIA_SEARCH: 2,
    PR_PERTNEG: 0,
    SHOW_REPEAT_VITALS: 0,
    PR_EXPOSURE: 0,
    DISPLAY_SECONDS: 0,
    PR_PT_CONDITION: 0,
    PR_PTRUN_ID: 0,
    PR_PTRUN_ID_LABEL: null,
    PR_PT_ID: 0,
    PR_PT_ID_LABEL: null,
    PR_DISP_FIELDS: 0,
    PR_MODE_DESCRIPTORS: 0,
    PR_REFREC_MODE: 0,
    PR_LOCAL_ID: 0,
    PR_LOCAL_ID_LABEL: null,
    PR_DISPATCHED_LOS: 0,
    PR_SIGNATURES: 0,
    USER_SECURITY_SCHEME: 0,
    EXTRA_SECURITY_CREW: 0,
    EXTRA_SECURITY_STATUS: 0,
    PR_TAIL_NUMBER: 0,
    PR_PTCAT_DISP_MAP: 0,
    TEAM_CAPABLE: 0,
    PR_DT_REC: 0,
    PR_DT_REC_DISABLE: 0,
    PR_DT_NOTIFY: 2,
    PR_DT_NOTIFY_DISABLE: 0,
    PR_DT_STANDBY: 0,
    PR_DT_STANDBY_DISABLE: 0,
    PR_DT_ACKNOWLEDGED: 0,
    PR_DT_ACKNOWLEDGED_DISABLE: 0,
    PR_DT_ENROUTE: 0,
    PR_DT_ENROUTE_DISABLE: 0,
    PR_DT_STAGING: 0,
    PR_DT_STAGING_DISABLE: 0,
    PR_DT_ARRIVE: 0,
    PR_DT_ARRIVE_DISABLE: 0,
    PR_DT_ARVREC: 0,
    PR_DT_ARVREC_DISABLE: 0,
    PR_DT_CALL_COMPLETED: 0,
    PR_DT_CALL_COMPLETED_DISABLE: 0,
    PR_DT_CANCEL: 1,
    PR_DT_CANCEL_DISABLE: 0,
    PR_CREW_PS: 0,
    PR_CREW_ROLE: 0,
    DEFAULT_TIMES_UNUSED: 0,
    DT_RANGE_FUTURE: 0,
    DT_RANGE_PAST: 0,
    PR_DT_LVREF: 0,
    PR_DT_LVREF_DISABLE: 0,
    CUSTOM_TIME1: null,
    CUSTOM_TIME1_LABEL: '',
    CUSTOM_TIME2: null,
    CUSTOM_TIME2_LABEL: '',
    CUSTOM_TIME3: null,
    CUSTOM_TIME3_LABEL: '',
    CUSTOM_TIME4: null,
    CUSTOM_TIME4_LABEL: '',
    PR_DT_CUSTOM_TIME1_DISABLE: 0,
    PR_DT_CUSTOM_TIME2_DISABLE: 0,
    PR_DT_CUSTOM_TIME3_DISABLE: 0,
    PR_DT_CUSTOM_TIME4_DISABLE: 0,
    SPECREP_REQ_SUBJECT: 0,
    SPECREP_REQ_SUP: 0,
    SPECREP_REQ_CAT: 0,
    SPECREP_REQ_NARRATIVE: 0,
    SPECREP_PSWPM: null,
    PR_PG6: 0,
    SESS_TIMEOUT: null,
    PR_PTRESIDENT: 0,
    PR_PTCITIZENSHIP: 0,
    AIR: 0,
  },
  commandFacilityConfig: {
    CMDFAC_ID: null,
    NAME: null,
    ADDR1: null,
    ADDR2: null,
    CITY: null,
    STATE: null,
    ZIP: null,
    CMDFAC_ADMIN: null,
    PHONE1: null,
    PHONE2: null,
    FAX1: null,
    FAX2: null,
    RPT_STATE: null,
    RPT_REGION: null,
    STATE_ID: null,
    PR_DT_INJURY: 0,
    PR_DT_ATPT: 0,
    PR_DT_LVPT: 0,
    PR_DT_TXCARE: 0,
    PT_IMPORT: 1,
    PAYROLL_STARTDAY: 0,
    PAYROLL_PERIODLENGTH: '2',
    PAYROLL_PERIODFIRSTDAY: null,
    PR_DT_FRESP: 0,
    PR_DT_INQTRS: 0,
    PR_DT_NOTIFY: 2,
    TIMEZONE: null,
    CAL_DAYS: null,
    TS_MODIFIED: null,
    MAP_NATIONAL_DEFAULTS: null,
    NEMSIS_COMPLIANCE_STATUS: null,
    NEMSIS_COMPLIANCE_DATE: null,
    EMAIL_DISCLAIMER: null,
    REGION_VIEW_USER_DATA: 0,
    NEMSIS3_COMPLIANCE_STATUS: null,
    NEMSIS3_COMPLIANCE_DATE: null,
    PR_DT_REC: 3,
    PR_DT_STANDBY: 3,
    PR_DT_ACKNOWLEDGED: 3,
    PR_DT_ENROUTE: 3,
    PR_DT_CANCEL: 3,
    PR_DT_ARRIVE: 0,
    PR_DT_TRANS_SCENE: 3,
    PR_DT_LVREF: 3,
    PR_DT_ARVREC: 3,
    PR_DT_CALL_COMPLETED: 3,
    CUSTOM_TIME1: null,
    CUSTOM_TIME1_LABEL: null,
    CUSTOM_TIME2: null,
    CUSTOM_TIME2_LABEL: null,
    CUSTOM_TIME3: null,
    CUSTOM_TIME3_LABEL: null,
    CUSTOM_TIME4: null,
    CUSTOM_TIME4_LABEL: null,
    PR_DT_STAGING: 3,
  },
  timeZone: null,
  cadImportConfig: {
    filter_unit: 0,
  },
  ekgImportConfig: {
    ekgAttachmentCategory: null,
  },
  datapointsConfig: {
    DP_AIRWAY_FAILURE: 0,
    DP_BELONGINGS: 0,
    DP_COMPDURATION: 0,
    DP_DISASTER: 0,
    DP_FACTORS: 0,
    DP_INJURY: 0,
    DP_HIDE_FIELDS_BY_STAFF: 0,
    DP_PR_DISP_DELAY: 0,
    DP_PR_TURNAROUND_DELAY: 0,
    DP_MOTOR_COMMENTS: 0,
    DP_MOTOR_PICKLIST: 0,
    DP_SENSORY_COMMENTS: 0,
    DP_SENSORY_PICKLIST: 0,
    DP_PUPIL_COMMENTS: 0,
    DP_PUPIL_PICKLIST: 0,
    DP_PUPIL_SIZELIST: 0,
    DP_STROKE_SCALE: 0,
    DP_THROMBOLYTIC: 0,
    DP_RTS: 0,
    DP_RTSCALC: 0,
    DP_INITGCS: 0,
    DP_PULSE_DORS: 0,
    DP_TEMP: 0,
    DP_EDEMA: 0,
    DP_ARTLINE: 0,
    DP_SWAN: 0,
    DP_SHOWDEFAULTS: 0,
    DP_BREATH_PICKLIST: 0,
    DP_BREATH_COMMENTS: 0,
    DP_NEURO_ASSESS: 0,
    DP_LAST_ORAL_INTAKE: 0,
    DP_LEVEL_CARE_PER_PROTOCOL: 0,
    DP_CARDIACARREST: 0,
    DP_CARDIACARREST_TIMES_UNKNOWN: 0,
    DP_VS_GLU: 0,
    DP_MVI: 0,
    DP_OTHER_COMPLAINT: 0,
    DP_SECCOMPLAINT: 0,
    DP_SYSTEM: 0,
    DP_SYMPTOMS: 0,
    DP_IMPRESSION: 0,
    DP_ANALOC: 0,
    DP_WORKING_DIAGNOSIS: 0,
    DP_MASSCAS: 0,
    DP_TRIAGE: 0,
    DP_INTRATHORACIC: 0,
    DP_GENERAL_EXTREMITIES: 0,
    DP_OTHER_AGENCIES: 0,
    DP_CUSTOMVITALS: 0,
    DP_OPT1_NAME: '',
    DP_OPT2_NAME: '',
    DP_CREW_PS: 0,
    DP_FLUIDS_COLL: 0,
    DP_FLUIDS_OTHER: 0,
    DP_PG6: 0,
    DP_PAIN_QUALITY: 0,
    DP_PAIN_QUALITY_REQ: 0,
    DP_PAIN: 0,
    DP_SHOCK_INDEX: 0,
    DP_SEDATION: 0,
    DP_WITHDRAWAL: 0,
    DP_MAXALT: 0,
    DP_IFR: 0,
  },
  isServiceConfigLoading: true,
  cmdFacChartDefaults: {
    NEURO_MOTOR: null,
    NEURO_SENSORY: null,
    PUPIL_REACT: null,
    MOTOR_LA: 1,
    MOTOR_LL: 1,
    MOTOR_RA: 1,
    MOTOR_RL: 1,
    SENSORY_LA: 1,
    SENSORY_LL: 1,
    SENSORY_RA: 1,
    SENSORY_RL: 1,
    PUPIL_RX_L: 8,
    PUPIL_RX_R: 1,
    PUPIL_SIZE_L: 8,
    PUPIL_SIZE_R: 8,
    PULSE_BRA_L: 0,
    PULSE_BRA_R: 0,
    PULSE_CAROTID_L: 4,
    PULSE_CAROTID_R: 4,
    PULSE_DORS_L: 4,
    PULSE_DORS_R: 4,
    PULSE_FEM_L: 4,
    PULSE_FEM_R: 4,
    PULSE_RAD_L: 1,
    PULSE_RAD_R: 1,
    HEAD_CONSCIOUSNESS: 1,
    CV_BREATH_SOUNDS_L: 1,
    CV_BREATH_SOUNDS_R: 1,
    CV_JVD: 2,
    CV_CAP_REFILL: 21,
    CV_EDEMA: 1,
    CV_RESP_EFFORT: 1,
    RESP_SOUNDS: null,
  },
  cmdFacProcedureDefaultAction: [],
  servicesBillingConfig: {
    ALS_ASSESS: 0,
    SCT_RN_IH: 0,
    SCT_MEDS: 0,
  },
  agencyNumberConfig: [],
  datasetDeterminationConfig: null,
  texasExportConfig: null,
  texasWristbandReportTypeConfig: null,
  appSettingsEntries: [],
}

export function configurationsReducer(
  state: IConfigurationsState = initialConfigurationsState,
  action: IConfigurationsAction
): IConfigurationsState {
  switch (action.type) {
    case ConfigurationsConstants.SET_SERVICE_CONFIG:
      return { ...state, serviceConfig: action.serviceConfig }
    case ConfigurationsConstants.SET_TIME_ZONE:
      return { ...state, timeZone: action.timeZone }
    case ConfigurationsConstants.SET_CAD_IMPORT_CONFIG:
      return { ...state, cadImportConfig: action.cadImportConfig }
    case ConfigurationsConstants.SET_EKG_IMPORT_CONFIG:
      return { ...state, ekgImportConfig: action.ekgImportConfig }
    case ConfigurationsConstants.SET_DATA_POINTS_CONFIG:
      return { ...state, datapointsConfig: action.datapointsConfig }
    case ConfigurationsConstants.SET_SERVICES_BILLING_CONFIG:
      return { ...state, servicesBillingConfig: action.servicesBillingConfig }
    case ConfigurationsConstants.SET_IS_SERVICE_CONFIG_LOADING:
      return { ...state, isServiceConfigLoading: action.isServiceConfigLoading }
    case ConfigurationsConstants.RESET_CONFIG:
      return { ...initialConfigurationsState }
    case ConfigurationsConstants.SET_COMMAND_FACILITY_CHART_DEFAULTS:
      return { ...state, cmdFacChartDefaults: action.cmdFacChartDefaults }
    case ConfigurationsConstants.SET_COMMAND_FACILITY_PROCEDURE_DEFAULT_ACTION:
      return { ...state, cmdFacProcedureDefaultAction: action.cmdFacProcedureDefaultAction }
    case ConfigurationsConstants.SET_COMMAND_FACILITY_CONFIG:
      return { ...state, commandFacilityConfig: action.commandFacilityConfig }
    case ConfigurationsConstants.SET_AGENCY_NUMBER_CONFIG:
      return { ...state, agencyNumberConfig: action.agencyNumberConfig }
    case ConfigurationsConstants.SET_AGENCY_NUMBER:
      return {
        ...state,
        agencyNumberConfig: state.agencyNumberConfig.map((datasetConfig) => {
          if (datasetConfig.dataset === action.dataset) {
            return {
              ...datasetConfig,
              agencyNumber: action.agencyNumber,
            }
          } else {
            return datasetConfig
          }
        }),
      }
    case ConfigurationsConstants.SET_DATASET_DETERMINATION_CONFIG:
      return { ...state, datasetDeterminationConfig: action.datasetDeterminationConfig }
    case ConfigurationsConstants.SET_TEXAS_EXPORT_CONFIG:
      return { ...state, texasExportConfig: action.texasExportConfig }
    case ConfigurationsConstants.SET_TEXAS_WRISTBAND_REPORT_TYPE_CONFIG:
      return { ...state, texasWristbandReportTypeConfig: action.texasWristbandReportTypeConfig }
    case ConfigurationsConstants.SET_APP_SETTINGS_ENTRIES:
      return { ...state, appSettingsEntries: action.appSettingsEntries }
    default:
      return state
  }
}
